import { Autocomplete } from '@fullscreendigital/carrefour-dex-fe'
import { Input } from 'components/core-ui/Input'
import { statusOptions } from '../helpers'

export const getColumns = () => [
  {
    title: 'METI Code',
    field: 'metiCode',
    align: 'left',
    type: 'string',
    disableSorting: true,
    width: '150px'
  },
  {
    title: 'SAP Code',
    field: 'sapCode',
    align: 'left',
    type: 'string',
    disableSorting: true,
    width: '150px'
  },
  {
    title: 'Name',
    field: 'name',
    align: 'left',
    type: 'string',
    disableSorting: true
  },
  {
    title: 'Managing Legal Entity',
    field: 'legalEntity',
    align: 'left',
    type: 'string',
    collapsible: true
  },
  {
    title: 'Assignments',
    field: 'activeAssignmentsCount',
    align: 'left',
    type: 'string',
    collapsible: true,
    disableSorting: true,
    width: '180px'
  },
  {
    field: 'isEnabled',
    title: 'Status',
    align: 'left',
    type: 'string',
    collapsible: true,
    width: '100px',
    render: row => row.status?.name
  }
]

export const getFilters = (typeOptions: AutocompleteOption[]) => {
  return [
    {
      name: 'subtype.name',
      value: '',
      filter: <Autocomplete variant="outlined" label="Type" options={typeOptions || []} />,
      type: 'autocomplete',
      label: 'Type'
    },
    {
      name: 'isEnabled',
      value: '',
      filter: <Autocomplete variant="outlined" label="Status" options={statusOptions || []} />,
      type: 'autocomplete',
      label: 'Status'
    }
  ]
}
